import httpClient from '../../api/axios-httpclient';
import NotificationUserAPI from '@/api/NotificationUserAPI.js';
import commonFunc from '@/common/commonFunction';
export default {
	/**
	 * Show thông báo đồng bộ dữ liệu từ CQT thuế hay không
	 * @returns
	 */
	showNotificationUser: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NotificationUserAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/notificationtaxaxion`
		});
		if (res && res.Data) {
			context.commit('updateNotificationUser', res.Data);
			return res.Data;
		}
		return res;
	},

	/**
	 * Cập nhật lại thời gian người dùng đóng thông báo đồng bộ dữ liệu từ CQT
	 * @returns
	 */
	updateCloseNotificationDate: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NotificationUserAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/updatedate`
		});
		if (res && res.Data) {
			return res.Data;
		}
		return res;
	},

	/**
	 * Show thông báo đồng bộ dữ liệu từ CQT thuế hay không
	 * @returns
	 */
	showNotificationInvoiceWaiting: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NotificationUserAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/notification-invoice-waitting`
		});
		if (res && res.Data) {
			context.commit('updateNotificationInvoiceWaiting', res.Data);
			return res.Data;
		}
		return res;
	},

	/**
	 * Thông báo thay đổi trạng thái hóa đơn trong cơ cấu tổ chức
	 */
	showNotificationChangeStatusInvoice: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NotificationUserAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/notification-changestatusinvoice`
		});
		if (res && res.Data) {
			context.commit('updateNotificationChangeStatusInvoice', res.Data);
			return res.Data;
		} else {
			context.commit('updateNotificationChangeStatusInvoice', false);
			return false;
		}
	},

	/**
	 * Loại bỏ thông báo
	 */
	removeNotificationChangeStatusInvoice: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NotificationUserAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/remove-noti-changestatusinvoice`
		});

		if (res && res.Data) {
			context.commit('updateNotificationChangeStatusInvoice', false);
			return res.Data;
		}
		return res;
	}
};
